module.exports = __webpack_public_path__ + "img/frame_alert.411ff924.png";